import createComponent2 from '@/helpers/createComponent2.js'
import ModalWindow2 from '@/components/Functional/ModalWindow2.vue'
import createComponent3 from '@/helpers/createComponent3.js'
import ModalWindow3 from '@/components/Functional/ModalWindow3.vue'
import ChatLangSwitcherModal from '@/components/ChatLangSwitcherModal/ChatLangSwitcherModal.vue'
import ReportModal from '@/components/ModalsNext/ReportModal/ReportModal.vue'
import CreatorGiftsModal from '@/components/CreatorGifts/Include/CreatorGiftsModal.vue'
import AppSignInByEmail from '@/components/App/AppSignInByEmail/AppSignInByEmail.vue'
import UnblockModal from '@/components/ModalsNext/UnblockModal.vue'
import BlockModal from '@/components/ModalsNext/BlockModal.vue'

function openChatLangSwitcherModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-md mx-auto w-full h-full flex'
  }

  createComponent2(ModalWindow2, modalProps, ChatLangSwitcherModal, props)
}

function openReportModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-md mx-auto w-full h-full flex'
  }

  createComponent2(ModalWindow2, modalProps, ReportModal, props)
}

function openCreatorGiftsCatalogModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-md mx-auto w-full h-full flex'
  }

  createComponent2(ModalWindow2, modalProps, CreatorGiftsModal, props)
}

function openUnblockModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-sm mx-auto w-full h-full flex'
  }

  createComponent3(ModalWindow3, modalProps, UnblockModal, props)
}

function openBlockModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-sm mx-auto w-full h-full flex'
  }

  createComponent3(ModalWindow3, modalProps, BlockModal, props)
}

function openSignInByEmailModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-md mx-auto w-full h-full flex'
  }

  createComponent3(ModalWindow3, modalProps, AppSignInByEmail, props)
}

export {
  openChatLangSwitcherModal,
  openReportModal,
  openCreatorGiftsCatalogModal,
  openBlockModal,
  openUnblockModal,
  openSignInByEmailModal
}